export const _domain_:string = (typeof location !== "undefined" && location.hostname !== "") ? (location.hostname) : ("localhost");
